import React from "react";
import glamorous from "glamorous";
import ReactTable from "react-table";

import ShipmentSearchBar from "./ShipmentSearchBar";
import SearchState from "./ShipmentSearchState";
import NameSearchModal from "./NameSearchModal";
import { getColumns } from "./ShipmentSearchColumns";
import { datatableThStyles, styleify } from "../../styles/table-styles";
import Colors from "../../styles/colors";

import CloseIcon from "react-icons/lib/io/close";

const Section = glamorous.section({
  display: "flex",
  flex: 1,
  flexDirection: "column",
  justifyContent: "space-between",
  padding: "1em",
  backgroundColor: "white"
});

export default class ShipmentSearchView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      resultsString: "",
      showNameSearchModal: false
    };
  }

  componentWillReceiveProps(nextProps) {
    // When finished loading a search, update the results string
    if (this.props.isLoading && !nextProps.isLoading) {
      this.updateResultsString(nextProps);
    }
  }

  updateResultsString(props) {
    const { totalShipments, searchObj, searchCategory, searchFilters } = props;

    const numFilters = Object.keys(searchFilters).length;

    const resultsString = (
      <glamorous.Div
        css={{
          flexDirection: "row",
          color: "#999",
          marginTop: "0.5em",
          marginBottom: "0.5em"
        }}
      >
        {"Viewing "}
        <glamorous.Span
          css={{ color: Colors.background.GRAY_BLUE, fontWeight: "bold" }}
        >{`${totalShipments} shipments`}</glamorous.Span>
        {searchObj.label && " for "}
        {searchObj.label && (
          <glamorous.Span
            css={{ color: Colors.background.GRAY_BLUE, fontWeight: "bold" }}
          >{`${SearchState.SEARCH_CATEGORIES[searchCategory].label}: ${
            searchObj.label
          }`}</glamorous.Span>
        )}
        {numFilters > 0 && " with "}
        {numFilters > 0 && (
          <glamorous.Span
            css={{ color: Colors.background.GRAY_BLUE, fontWeight: "bold" }}
          >{`${numFilters} ${
            numFilters > 1 ? "filters" : "filter"
          }`}</glamorous.Span>
        )}
      </glamorous.Div>
    );

    this.setState({ resultsString });
  }

  render() {
    const {
      shipments,
      lads,
      isLoading,
      page,
      pageSize,
      totalPages,
      setPagination,
      setSort,
      resetSearch
    } = this.props;
    const { resultsString, showNameSearchModal } = this.state;
    const columns = getColumns(lads);

    const tableTrProps = (state, rowInfo, column, instance) => {
      return {
        onClick: e => {
          const shipmentID = rowInfo.original.id;
          this.props.pushShipmentDetailView(shipmentID);
        },
        style: { cursor: "pointer" }
      };
    };

    /*
    const saveSearchDiv = () => {
      return (
        <glamorous.Div
          css={{
            color: "#999",
            marginLeft: "1em",
            fontStyle: "italic",
            textDecoration: "underline",
            ":hover": {
              cursor: "pointer",
              color: Colors.background.DARK_BLUE
            }
          }}
          onClick={() => this.setState({ showNameSearchModal: true })}
        >
          Save this search
        </glamorous.Div>
      );
    };
    */

    return (
      <Section>
        <ShipmentSearchBar showFilters />
        <glamorous.Div
          display="flex"
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between"
        >
          {resultsString}
          {resultsString && (
            <glamorous.Div
              display="flex"
              flexDirection="row"
              alignItems="center"
              justifyContent="flex-start"
            >
              <glamorous.Div
                css={{
                  color: "#999",
                  marginLeft: "1em",
                  fontStyle: "italic",
                  textDecoration: "underline",
                  ":hover": {
                    cursor: "pointer",
                    color: Colors.background.DARK_BLUE
                  }
                }}
                onClick={() => resetSearch()}
              >
                Reset{" "}
                <CloseIcon
                  style={{
                    borderWidth: "1px",
                    borderStyle: "solid",
                    padding: "2px",
                    borderRadius: "1em",
                    marginLeft: "0.25em"
                  }}
                />
              </glamorous.Div>
              <glamorous.Div
                css={{
                  width: "1px",
                  height: "2em",
                  marginLeft: "1em",
                  backgroundColor: Colors.background.LIGHT_GRAY
                }}
              />
            </glamorous.Div>
          )}
        </glamorous.Div>
        <ReactTable
          manual
          pages={totalPages}
          page={page}
          pageSize={pageSize}
          onPageChange={newPage => setPagination(newPage, pageSize)}
          onPageSizeChange={newPageSize => setPagination(0, newPageSize)}
          onSortedChange={newSorted =>
            setSort(newSorted[0].id, newSorted[0].desc)
          }
          data={shipments}
          columns={columns}
          loading={isLoading}
          getTheadThProps={styleify(datatableThStyles)}
          getTrProps={tableTrProps}
        />
        <NameSearchModal
          show={showNameSearchModal}
          hide={() => this.setState({ showNameSearchModal: false })}
        />
      </Section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/shipment-search/ShipmentSearchView.js